import React, { memo } from 'react';
import { vkMusicBundleLicenseLink } from 'reactApp/appHelpers/featuresHelpers/features/vkMusicBundle';

import styles from './VkMusicBundleLicenseNote.css';

export const VkMusicBundleLicenseNote = memo(() => {
    return (
        <div className={styles.footer}>
            <span>
                Реклама. ООО «ВК», ИНН 7743001840. Условия предоставления{' '}
                <a rel="noreferrer" target="_blank" href={vkMusicBundleLicenseLink}>
                    Специального предложения
                </a>
            </span>
        </div>
    );
});

VkMusicBundleLicenseNote.displayName = 'VkMusicBundleLicenseNote';
